import clsx from 'clsx';
import { Avatar, type AvatarSize } from './Avatar';

/**
 * Design System · FacesStack
 * Avatares sobrepostos (estilo Monday) — participantes que já tocaram o card.
 * Cada rosto mantém seu tooltip (nome + papel). Limita e mostra "+N".
 */

export interface Participante {
  id: string;
  nome: string;
  avatarUrl?: string;
  /** papel na tarefa (ex.: "Roteiro", "Captação", "Edição"). */
  papel?: string;
  /** marca como responsável atual (anel azul). */
  atual?: boolean;
}

interface FacesStackProps {
  pessoas: Participante[];
  size?: AvatarSize;
  /** máximo de rostos antes de agrupar em "+N". default 5. */
  max?: number;
  className?: string;
}

export function FacesStack({ pessoas, size = 'md', max = 5, className }: FacesStackProps) {
  const visiveis = pessoas.slice(0, max);
  const resto = pessoas.length - visiveis.length;

  const overlap = size === 'sm' ? '-ml-1.5' : '-ml-2';
  const moreSize = size === 'sm' ? 'w-6 h-6 text-[9px]' : size === 'lg' ? 'w-11 h-11 text-xs' : 'w-9 h-9 text-[10px]';

  return (
    <div className={clsx('flex items-center', className)}>
      {visiveis.map((p, i) => (
        <span key={p.id} className={clsx(i > 0 && overlap)}>
          <Avatar nome={p.nome} avatarUrl={p.avatarUrl} papel={p.papel} size={size} ring={p.atual} />
        </span>
      ))}
      {resto > 0 && (
        <span
          className={clsx(
            'flex items-center justify-center rounded-full font-bold border-2 border-panel bg-panel-3 text-text-2',
            moreSize,
            overlap,
          )}
          title={pessoas.slice(max).map((p) => p.nome).join(', ')}
        >
          +{resto}
        </span>
      )}
    </div>
  );
}
